// `п. 39` (`ФЗ-152`, `ПД-03`): колонка «Владелец» в окне модуля показывает
// **состояние связи**, а не человека.
//
// Прежде здесь стояла почта владельца (`DEV-56`): любой вошедший по чужому номеру
// объекта получал персональные данные третьего лица. Сервер их больше не отдаёт, а
// состояние связи отвечает на тот же практический вопрос — «место занято или
// нет» — без единой буквы о человеке.

export type OwnerLinkState = "active" | "invited" | "none";

export interface IOwnerLink {
  state: OwnerLinkState;
  /** Начало связи (ISO) — только у действующей. */
  since: string | null;
  /** Номер учётной записи: приходит **только** роли `root`. */
  user_id?: number;
}

/** Что видно в колонке — без имён, адресов и телефонов. */
export function ownerLinkText(ownerLink?: IOwnerLink | null): string {
  const state = ownerLink?.state;

  if (state === "active") {
    const since = formatOwnerDay(ownerLink?.since);

    return since ? `активен с ${since}` : "активен";
  }

  if (state === "invited") return "приглашён";

  return "не внесён";
}

/** Дата связи — «01.09.2026»: в колонке место для короткой записи. */
export function formatOwnerDay(iso?: string | null): string | null {
  if (!iso) return null;

  const at = new Date(iso);

  if (Number.isNaN(at.getTime())) return null;

  const day = String(at.getDate()).padStart(2, "0");
  const month = String(at.getMonth() + 1).padStart(2, "0");

  return `${day}.${month}.${at.getFullYear()}`;
}

/**
 * Номер учётной записи для ссылки на карточку. Есть он только у `root`: сервер
 * отдаёт `user_id` одной этой роли, и фронт не должен делать вид, что знает
 * владельца, если номера нет.
 */
export function ownerCardUserId(ownerLink?: IOwnerLink | null): number | null {
  const userId = ownerLink?.user_id;

  return typeof userId === "number" && Number.isFinite(userId) ? userId : null;
}

/** Куда ведёт ссылка: карточка человека в списке пользователей. */
export function ownerCardHref(userId: number): string {
  return `/users?userId=${userId}`;
}
